<template>
  <div>
    <van-field :label="title" :required="required" :disabled="disabled">
      <template #input>
        <van-uploader
          v-if="!disabled"
          :disabled="disabled"
          v-model="list"
          accept="image/*,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          :deletable="!disabled"
          @click-preview="imageView"
          :preview-full-image="false"
          :after-read="beforeUpload"
          :before-delete="(file) => beforeDelteFile(file)"
        />
        <div class="file-show" v-else>
          <div v-for="item in list" :key="item.url" class="fujian">
            <span @click="imageView(item)">{{ item.name }}</span>
          </div>
        </div>
      </template>
    </van-field>
    <pdfShow
      :isModel="true"
      @closePdfModel="
        () => {
          isShowPdf = false;
        }
      "
      class="pdf"
      v-if="isShowPdf"
    />
    <!--图片预览-->
    <van-image-preview
      v-model="show.imageView"
      :images="imageParam.list"
      :loop="false"
    />
  </div>
</template>

<script>
import { Base64 } from "js-base64";
import pdfShow from "@/components/homePage/pdfShow/pdfShow.vue";
export default {
  props: {
    title: {
      type: String,
      default: "附件",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    detailType: {
      type: String,
      default: "",
    },
    fileSystem: {
      type: Object,
      default: {
        sys: "",
        module: "",
        entityClass: "",
        viewByAnon: true,
        longLife: false,
      },
    },
    filePart: {
      type: String,
      default: "",
    },
    detailId: {
      type: String,
      default: "",
    },
    required:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isShowPdf: false,
      isLoading: false,
      list: [],
      imageParam: {
        list: [],
      },
      show: {
        imageView: false,
      },
    };
  },
  components: {
    pdfShow,
  },
  methods: {
    beforeDelteFile(file) {
      console.log(file);
      if (file.id && file.attachId) {
        this.unBingFile(file.id, file.attachId);
      }
      return true;
    },
    // 解绑已绑定的文件
    unBingFile(fileId, attachId, callback) {
      this.$httpPost(
        `${this.$store.state.httpHost.file}/japi/filesystem/attachment/removeBindBatch?attachment=${attachId}&fileInfo=${fileId}`
      )
        .then((res) => {
          if (callback) callback();
        })
        .catch((res) => {
          console.log("请求出现错误", res);
          this.$toast("请求失败!");
        });
    },
    // 手机端预览文件
    imageView(fileItem) {
      let type = String(
        fileItem.name.split(".")[fileItem.name.split(".").length - 1]
      );
      if (
        type !== "jpg" &&
        type !== "jpeg" &&
        type !== "png" &&
        type !== "svg"
      ) {
        this.previewFile(fileItem.id);
      } else {
        // 如果是图片
        this.$httpPost(
          this.$store.state.httpHost.file +
            `/japi/filesystem/getFilePreview?id=${fileItem.id}&browserType=1`
        )
          .then((res) => {
            console.log(res, "接口返回值");
            console.log(`${this.$store.state.httpHost.base}` + res.data.url);
            this.imageParam.list = [
              res.data.url.replace("/file", this.$store.state.httpHost.file),
            ];
            this.show.imageView = true;
          })
          .catch((res) => {
            console.log(res);
          });
      }
    },
    previewFile(id) {
      this.$ContinueToast("请稍后，正在转换为pdf预览");
      this.$httpPost(
        `${this.$store.state.httpHost.file}/japi/filesystem/minIoPreview?id=${id}`,
        {}
      )
        .then((res) => {
          this.$toast.clear();
          let type = res.data.data.split(".");
          type = type[type.length - 1];
          sessionStorage.setItem("pdfUrl", Base64.encode(res.data.data));
          this.isShowPdf = true;
          // this.$router.push({
          //   name: "pdfShow",
          // });
        })
        .catch((res) => {
          console.log(res);
          this.$ClearTips();
          console.log(res);
        });
    },
    beforeUpload(data) {
      const { file } = data;
      if (file.size > 2000 * 1024 * 1024) {
        this.$toast("上传文件大小不能超过500M");
        return;
      }
      console.log(file);

      let fd = new FormData();
      fd.append("file", file);
      this.$httpPost(
        `${this.$store.state.httpHost.file}/japi/filesystem/upload?maxFileSize=${file.size}&viewByAnon=true&longLife=false`,
        fd,
        {
          headers: {
            "Content-Type":
              "multipart/form-data; boundary=----WebKitFormBoundaryIOi8qEBAFV1KN25n",
          },
        }
      )
        .then(async (res) => {
          if (res.data.status === 1) {
            //   name: file.name,
            // size: file.size,
            // url: res.data.link,
            // id: res.data.id,
            const lastFile = this.list[this.list.length - 1];
            if (lastFile) {
              lastFile.name = file.name;
              lastFile.size = file.size;
              lastFile.url = res.data.link;
              lastFile.id = res.data.id;
            }
            // 非新建时绑定文件
            if (this.detailType !== "build") {
              await this.bingFileForm(
                [res.data.id],
                this.filePart,
                this.detailId,
                (res) => {
                  if (res.status === 1) {
                    console.log("bingFileForm", res);
                    const attachId = res.idSet[0] || "";
                    lastFile.attachId = attachId;
                  } else {
                    this.$notify(res.message);
                  }
                }
              );
            }
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((res) => {
          console.log("请求出现错误", res);
          this.$toast(this.$route.name + "上传文件前-请求失败");
        });
    },
    bindAllFile(id) {
      if (this.disabled) {
        return;
      }
      let arr = [];
      this.list.forEach((item) => {
        if (item.id) {
          arr.push(item.id);
        }
      });
      this.bingFileForm(arr, this.filePart, id);
    },
    // 绑定文件到表单
    bingFileForm(fileIdsArray, part, id, callback) {
      if (fileIdsArray.length === 0) return;
      this.$httpPost(
        this.$store.state.httpHost.file +
          "/japi/filesystem/attachment/bindBigBatch",
        [
          {
            fileid: fileIdsArray, // 文件列表
            form: id, // 表单
            sys: this.fileSystem.sys,
            module: this.fileSystem.module,
            part: part,
          },
        ]
      )
        .then((res) => {
          if (res.data.status === 1) {
            if (callback) callback(res.data);
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((res) => {
          console.log("请求出现错误", res);
          this.$toast("请求失败!");
        });
    },
    // 获取绑定的附件
    async getFiles(cb) {
      await this.$httpGet(
        `${this.$store.state.httpHost.file}/japi/filesystem/attachment/getFilesByAttach?sys=${this.fileSystem.sys}&module=${this.fileSystem.module}&form=${this.detailId}`
      )
        .then((res) => {
          console.log(res, "========");
          if (res.data.status === 1) {
            let data = res.data;
            data.attachinfos.forEach((item) => {
              let files = item.fileInfo;
              let attachId = item.id;
              let part = item.part;
              files.forEach((val) => {
                val.attachId = attachId;
                val.url = this.$store.state.httpHost.file + val.link;
                val.realName = val.name;
                // val.isImage = true;
                let type = String(
                  val.name.split(".")[val.name.split(".").length - 1]
                );
                if (
                  type !== "jpg" &&
                  type !== "jpeg" &&
                  type !== "png" &&
                  type !== "svg"
                ) {
                  val.isImage = false;
                } else {
                  val.isImage = true;
                }
                this.list.push(val);
              });
            });
            // data.fileList.forEach((item) => {
            //   let type = String(
            //     item.name.split(".")[item.name.split(".").length - 1]
            //   );
            //   if (
            //     type !== "jpg" &&
            //     type !== "jpeg" &&
            //     type !== "png" &&
            //     type !== "svg"
            //   ) {
            //     item.isImage = false;
            //   } else {
            //     item.isImage = true;
            //   }
            //   this.list.push({
            //     ...item,
            //     attachId: this.attachId,
            //     url: this.$store.state.httpHost.file + item.link,
            //     realName: item.name,
            //     isImage: item.isImage,
            //   });
            // });
            //回调方法
            if (cb) {
              cb(data);
            }
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res, "=========");
          this.$toast("请求失败!");
        });
    },
    async getFilesByPart(cb) {
      await this.$httpGet(
        `${this.$store.state.httpHost.file}/japi/filesystem/attachment/getFilesByAttach?sys=${this.fileSystem.sys}&module=${this.fileSystem.module}&form=${this.detailId}`
      )
        .then((res) => {
          console.log(res, "========");
          if (res.data.status === 1) {
            let data = res.data;
            data.attachinfos.forEach((item) => {
              let files = item.fileInfo;
              let attachId = item.id;
              let part = item.part;
              if (part == this.filePart) {
                files.forEach((val) => {
                  val.attachId = attachId;
                  val.url = this.$store.state.httpHost.file + val.link;
                  val.realName = val.name;
                  // val.isImage = true;
                  let type = String(
                    val.name.split(".")[val.name.split(".").length - 1]
                  );
                  if (
                    type !== "jpg" &&
                    type !== "jpeg" &&
                    type !== "png" &&
                    type !== "svg"
                  ) {
                    val.isImage = false;
                  } else {
                    val.isImage = true;
                  }
                  this.list.push(val);
                });
              }
            });
            //回调方法
            if (cb) {
              cb(data);
            }
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res, "=========");
          this.$toast("请求失败!");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.pdf {
  position: fixed;
  max-height: 100%;
  overflow-y: auto;
  background-color: #fff;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-overflow-scrolling: touch;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2062;
}
.fujian {
    width: 100%;
    margin-bottom: 16.7px;
    span {
      text-decoration: underline;
      color: rgba(70, 101, 202, 1);
      overflow: auto;
      width: 100%;
      display: block;
      overflow-wrap: anywhere;
    }
  }
</style>


// WEBPACK FOOTER //
// src/cmscomponents/cmsUploadFile/cmsUploadFile.vue